module.exports = __webpack_public_path__ + "img/22.44a3fcde.jpg";